namespace TabAurous.Inventory {
    export interface BranchOutForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        BranchId: Serenity.LookupEditor;
        DepartmentId: Serenity.LookupEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: BranchOutItemsEditor;
        TaxDetails: BranchOutTaxEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class BranchOutForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.BranchOut';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BranchOutForm.init)  {
                BranchOutForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = BranchOutItemsEditor;
                var w8 = BranchOutTaxEditor;
                var w9 = s.DecimalEditor;
                var w10 = s.TextAreaEditor;

                Q.initFormType(BranchOutForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'BranchId', w5,
                    'DepartmentId', w5,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'UserId', w5,
                    'EmployeeId', w3,
                    'ProductItemImage', w6,
                    'ItemDetails', w7,
                    'TaxDetails', w8,
                    'Pieces', w3,
                    'Weight', w9,
                    'NetWeight', w9,
                    'NetAmount', w9,
                    'TaxAmount', w9,
                    'Discount', w9,
                    'AdditionalCharges', w9,
                    'GrossAmount', w9,
                    'Remark', w10,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CurrencyId', w5,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
